module.exports = __webpack_public_path__ + "static/media/FCPSR_B.8b922afb.svg";